import { GetServerSideProps } from 'next';

import {
  createSearchResultsPage,
  SearchResultsServerSideProps,
} from '../../components/search-results/search-results-page';
// Server only - kept in its own module so the client bundle does not pull in
// the Node dependencies behind getServerSideProps
import { getSearchResultsPageServerSideProps } from '../../components/search-results/get-search-results-page-server-side-props';

export default createSearchResultsPage({ isAgency: false });

export const getServerSideProps: GetServerSideProps<
  SearchResultsServerSideProps
> = async (context) =>
  getSearchResultsPageServerSideProps(context, { isAgency: false });
